// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/altimeter-setting-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/altimeter-setting-procedures/altimeter-setting-procedures.js';

mount([g0]);
